<template>
  <div
    id="message_main"
    class="message_main"
  >
    <div class="main">
      <TitleBar
        title="意見反映"
        :introduction="{
          link: 'https://www.smartdaily.com.tw/opinion-reflection/',
          product_id: 'feedback',
          product_name: '意見反映',
          subpage_name: ''
        }"
        tip="社區住戶於APP上所反映的意見，可在此回覆與溝通。"
      />
      <FilterFrame
        ref="filter"
        :filter-form="messageFilter"
        @search="search"
        @clear="clearSearch()"
        @onSearchValue="checkExportRule"
      />
      <div class="title_bar center">
        <div class="left" />
        <div class="right">
          <span>搜尋結果共計 {{ totalNum }} 筆</span>
          <el-button
            :disabled="!canClickButton"
            icon="icon-output"
            round
            @click="onSearchValue()"
          >
            匯出
          </el-button>
        </div>
      </div>
      <el-table
        ref="messageList"
        v-loading="loading"
        :data="ListData"
        ety-text="目前無任何住戶意見反映"
        :cell-class-name="cellStyle"
        :header-cell-class-name="cellStyle"
        class="messagelist"
        @sort-change="tableSort"
      >
        <el-table-column
          type="index"
          align="left"
          width="50"
        />
        <el-table-column
          prop="TabletNote"
          align="left"
          label="戶別"
          width="160"
        >
          <template slot-scope="scope">
            <template>{{ scope.row.TabletNote || '-' }}</template>
          </template>
        </el-table-column>
        <el-table-column
          prop="UserName"
          align="left"
          label="留言人"
          width="160"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.UserName ? scope.row.UserName : scope.row.UserName === '' ? $t('Message.NoRegisteredName') : '-' }}</div>
            <div v-if="scope.row.UserTabletState !== 1" class="fontred">
              {{ userTabletStateMap[scope.row.UserTabletState] }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="CreateAt"
          align="left"
          label="留言日期"
          width="105"
          sortable
        />
        <el-table-column
          prop="Content"
          header-align="left"
          label="內容"
        >
          <template slot-scope="scope">
            <el-tag type="type">
              {{ scope.row.Type }}
            </el-tag>
            <br>
            <span class="contentRow">{{ scope.row.Content }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="ReplyName"
          align="left"
          label="回覆人"
          width="100"
        />
        <el-table-column
          prop="ReplyAt"
          align="left"
          label="回覆日期"
          width="105"
          sortable
        />
        <el-table-column
          prop="ReplyIsRead"
          align="left"
          label="回覆推播"
          width="55"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.ReplyIsRead">已讀</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="ReplyAt"
          align="left"
          label="操作"
          width="85"
        >
          <template slot-scope="scope">
            <router-link
              v-if="scope.row.UserTabletState !== 1"
              :to="{
                name: 'messageView',
                params:{ id :scope.row.Id }
              }"
              class="el-button el-button--default el-button--mini is-plain edit"
            >
              {{ $t('Message.View') }}
            </router-link>
            <router-link
              v-else-if="scope.row.ReplyAt !== ''"
              :to="{
                name: 'messageReply',
                params:{
                  id:scope.row.Id
                }
              }"
              class="el-button el-button--default el-button--mini is-plain edit"
            >
              修改
            </router-link>
            <router-link
              v-else
              :to="`/messageReply/${scope.row.Id}`"
              class="el-button el-button--warning el-button--mini is-plain reply"
            >
              回覆
            </router-link>
          </template>
        </el-table-column>
      </el-table>
      <TableLoading :is-loading="loading" />
    </div>
  </div>
</template>

<script>
import TableLoading from '@/components/TableLoading'
import FilterFrame from '@/components/FilterFrame'
import TitleBar from '@/components/PageTitleBar.vue'
import { setTimeout } from 'timers'
export default {
  components: {
    FilterFrame,
    TableLoading,
    TitleBar
  },
  beforeRouteEnter (to, from, next) {
    if (from.name === 'messageReply') {
      next(vm => {
        vm.$nextTick(() => {
          if (vm.$store.state.message.edited) {
            vm.$refs.filter.onClear()
            vm.$store.commit('ifMessageReplyEdit', false)
          } else if (vm.$store.state.message.height != null) {
            document.documentElement.scrollTop = vm.$store.state.message.height
          }
        })
      })
    }
    next()
  },
  beforeRouteLeave (to, from, next) {
    if (to.name !== 'messageReply') {
      this.$store.commit('giveMessageHeight', null)
    } else {
      this.setHeight()
    }
    next()
  },
  data () {
    return {
      filter: {},
      messageFilter: [
        {
          label: '戶別',
          name: 'household',
          type: 'house',
          value: ''
        },
        {
          label: '類別',
          name: 'type',
          type: 'select',
          options: [],
          value: ''
        },
        {
          label: '回覆',
          name: 'IsReply',
          type: 'select',
          options: [
            {
              label: '請選擇',
              value: ''
            },
            {
              label: '未回覆',
              value: false
            },
            {
              label: '已回覆',
              value: true
            }
          ],
          value: ''
        },
        {
          label: '留言日期',
          name: 'messageDate',
          type: 'date'
        }
      ],
      ListData: [],
      offset: 0,
      loading: false,
      scrollEnd: false,
      totalNum: 0,
      startDay: '',
      endDay: '',
      column: '',
      sort: '',
      canClickButton: true,
      userTabletStateMap: {
        2: this.$t('Message.LeavedUser'),
        3: this.$t('Message.DeletedUser')
      }
    }
  },
  mounted () {
    this.getList(true)
    this.getTypeList()
    window.addEventListener('scroll', this.autoShow, true)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.autoShow, true)
  },
  methods: {
    // 查詢
    search (such_val) {
      if (this.canClickButton) {
        this.canClickButton = false
        this.ListData = []
        this.filter = {
          TabletId: such_val.household === undefined ? '' : such_val.household.TabletId,
          Type: such_val.type === undefined ? '' : such_val.type,
          IsReply: such_val.IsReply === undefined ? '' : such_val.IsReply,
          'CreateAt.StartAt': such_val.messageDate === null || such_val.messageDate === undefined ? '' : such_val.messageDate[0],
          'CreateAt.EndAt': such_val.messageDate === null || such_val.messageDate === undefined ? '' : such_val.messageDate[1]
        }
        this.offset = 0
        this.scrollEnd = false
        window.scrollTo(0, 0)
        this.getList(true)
      }
      setTimeout(() => {
        this.canClickButton = true
      }, 1000)
    },
    // 清除搜尋條件
    clearSearch () {
      if (this.canClickButton) {
        this.canClickButton = false
        this.filter = {}
        this.sort = ''
        this.column = ''
        this.$refs.messageList.clearSort()
        this.ListData = []
        this.offset = 0
        this.loading = true
        this.scrollEnd = false
        window.scrollTo(0, 0)
        this.getList(true)
      }
      setTimeout(() => {
        this.canClickButton = true
      }, 1000)
    },
    // 列表資料、查詢
    getList (getTotalNum = true) {
      this.canClickButton = false
      this.loading = true
      const requestData = {
        Offset: this.offset,
        MaxCount: 10
      }
      if (this.sort !== '') { requestData.Sort = this.sort === 'descending' ? 'DESC' : 'ASC' }
      if (this.column !== '') { requestData.Column = this.column }
      Object.keys(this.filter).forEach((val) => {
        if (this.filter[val] !== '') {
          requestData[val] = this.filter[val]
        }
      })
      return apiMessage.List.GetMessageList(
        requestData
      ).then(async (res) => {
        if (res.data.Data.length !== 0) {
          await this.$sleep(1000, res.duration)
          res.data.Data.forEach((item) => {
            item.ReplyAt = (item.ReplyAt != null) ? item.ReplyAt.slice(0, 16) : ''
            item.CreateAt = (item.CreateAt != null) ? item.CreateAt.slice(0, 16) : ''
            this.ListData.push(item)
          })
          if (getTotalNum) { this.getTotalNum(requestData, false) }
          if (res.data.Data.length < 10) { this.scrollEnd = true }
        } else {
          this.scrollEnd = true
          this.totalNum = this.ListData.length > 0 ? this.totalNum : 0
        }
        this.canClickButton = true
        this.loading = false
        return true
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
        this.canClickButton = true
        this.loading = false
        return false
      })
    },
    // 類別資料
    getTypeList () {
      setTimeout(() => {
        apiMessage.List.GetMessageType().then((res) => {
          this.messageFilter[1].options = []
          this.messageFilter[1].options.push({ label: '請選擇', value: '' })
          res.data.Data.forEach((val) => {
            this.messageFilter[1].options.push({
              label: val.Name,
              value: val.Id
            })
          })
        }).catch((err) => {
          console.log('錯誤訊息：', err.response)
        })
      }, 1500)
    },
    // 取得總筆數，或匯出前條件筆數檢查用
    getTotalNum (requestData, isExport) {
      delete requestData.Offset
      delete requestData.MaxCount
      apiMessage.List.GetMessageTotal(
        requestData
      ).then((res) => {
        if (isExport) {
          if (res.data.Data === 0) {
            this.$alert(
              '目前符合條件的資料筆數為 0 筆，請重新選擇資料篩選的條件。',
              '錯誤',
              {
                confirmButtonText: '確定',
                type: 'error',
                callback: action => {}
              }
            )
            this.canClickButton = true
          } else {
            this.exportExcel(requestData)
          }
        } else {
          this.totalNum = res.data.Data
        }
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
      })
    },
    // 點擊匯出按鈕不會運行getList()
    onSearchValue () {
      if (this.canClickButton) { this.$refs.filter.onSearchValue() }
    },
    // 檢查匯出條件
    checkExportRule (such_val) {
      this.canClickButton = false
      const filter = {
        TabletId: such_val.household === undefined ? '' : such_val.household.TabletId,
        Type: such_val.type === undefined ? '' : such_val.type,
        IsReply: such_val.IsReply === undefined ? '' : such_val.IsReply,
        'CreateAt.StartAt': such_val.messageDate === null || such_val.messageDate === undefined ? '' : such_val.messageDate[0],
        'CreateAt.EndAt': such_val.messageDate === null || such_val.messageDate === undefined ? '' : such_val.messageDate[1]
      }
      // eslint-disable-next-line eqeqeq
      const day1 = filter['CreateAt.StartAt'] != '' ? filter['CreateAt.StartAt'] : ''
      // eslint-disable-next-line eqeqeq
      const day2 = filter['CreateAt.EndAt'] != '' ? filter['CreateAt.EndAt'] : ''
      if (day1 !== '' && day2 !== '') {
        const dateDiff = dayDiff(day1, day2)
        if (dateDiff <= 90) {
          const data = {}
          Object.keys(filter).forEach((val) => {
            if (filter[val] !== '') {
              data[val] = filter[val]
            }
          })
          this.getTotalNum(data, true)
        } else {
          this.$alert('系統一次匯出資料量最大限制為三個月，如需匯出超過三個月，建議您多次分批匯出即可', '錯誤', {
            confirmButtonText: '確定',
            type: 'error',
            callback: action => {}
          })
          this.canClickButton = true
        }
      } else {
        this.$alert('您未輸入起始日', '錯誤', {
          confirmButtonText: '確定',
          type: 'error',
          callback: action => {}
        })
        this.canClickButton = true
      }
      function dayDiff (startDay, endDay) {
        const startDate = new Date(startDay)
        const endDate = new Date(endDay)
        const diffDays = parseInt(Math.abs(startDate - endDate) / 1000 / 60 / 60 / 24)
        return diffDays
      }
    },
    // 匯出
    exportExcel (data) {
      const requestData = data
      if (this.sort !== '') { requestData.Sort = this.sort === 'descending' ? 'DESC' : 'ASC' }
      if (this.column !== '') { requestData.Column = this.column }
      const config = {
        responseType: 'blob'
      }
      apiMessage.List.GetMessageExport(
        requestData,
        config
      ).then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${decodeURIComponent(res.headers['content-disposition'].split(';')[1].split('=')[1].replace('_________', '智生活意見反映紀錄'))}`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
      })
      this.canClickButton = true
    },
    // 監聽列表排序
    tableSort (column, prop, order) {
      this.loading = true
      if (this.column !== column.prop || this.sort !== column.order) {
        this.column = column.prop
        this.sort = column.order
        this.offset = 0
        this.ListData = []
        this.scrollEnd = false
        this.getList(false)
      }
    },
    // 下拉到底自動載入
    autoShow () {
      const ScrollTop = document.documentElement.scrollTop
      const ClientHeight = document.documentElement.clientHeight
      const ScrollHeight = document.documentElement.scrollHeight
      // eslint-disable-next-line eqeqeq
      if (ScrollTop + ClientHeight >= ScrollHeight - 20 && !this.loading && this.$router.currentRoute.name == 'message') {
        if (!this.scrollEnd) {
          this.offset += 10
          this.$handleScroll(this.getList)
        }
      }
    },
    // 將 button 改為連結，故移除用不到的 method
    setHeight () {
      this.$store.commit('giveMessageHeight', document.documentElement.scrollTop)
    },
    cellStyle ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 4) { return 'columnIndex4' }
      if (columnIndex === 7) { return 'columnIndex7' }
    }
  }
}
</script>

<style lang="sass" scoped>
#message_main
  +mainLayer
  .messagelist
    font-size: 15px
  ::v-deep .el-table
    +basicTable
    &__body a.el-button--default
        color: #333
    &__body a.el-button--warning
        color: #f79256
    .el-loading-mask
      height: 65px
      .el-loading-spinner
        .circular
          display: none
    @media (min-width:1400px)
      .columnIndex4.th
        .cell
          padding-left: 0px
          padding-right: 0px
      .columnIndex4
        .cell
          padding-left: 40px
          padding-right: 40px
    .columnIndex7
      width: 55px
    .el-tag
      margin-bottom: 3px
  .contentRow
    display: -webkit-box
    -webkit-line-clamp: 3
    -webkit-box-orient: vertical
    white-space: normal
    word-wrap: break-word

  .fontred
    color: $dangerColorHover
</style>
